import React, { ReactNode, useContext } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { CssBaseline, Box, Typography, Container, Grid, Link } from '@material-ui/core'

import MainBar from '../components/layout/MainBar'
import Menu from '../components/layout/Menu'
import { LayoutContext } from '../context/LayoutContext'
import { drawerWidth } from '../types/Layout'
import Info from './Info'

function Copyright () {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      <Link color="inherit" href="/">
        Portal Analytics
      </Link>{' '}
    </Typography>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    paddingLeft: theme.spacing(10)
  },
  menuOpen: {
    paddingLeft: drawerWidth
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    overflow: 'auto'
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  }
}))

type Props = {
  children: ReactNode
}

export default function MainTemplate ({ children }: Props): JSX.Element {
  const classes = useStyles()
  const { layout } = useContext(LayoutContext)

  return (
    <div className={clsx(classes.root, layout.isMenuOpen && classes.menuOpen)}>
      <CssBaseline />
      <Menu />
      <MainBar/>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Info />
          <Grid>
            {children}
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  )
}
